export function NumberValue(input: any) {
  const number = parseInt(input)
  if (Number.isNaN(number)) {
    return null
  } else {
    return number
  }
}

export function FloatValue(input: any, defaultValue = 1) {
  const number = parseFloat(input)
  if (Number.isNaN(number)) {
    return null
  } else {
    return number
  }
}

export { NumberValue as Number }
export { FloatValue as Float }
